import React from 'react'
import PropTypes from 'prop-types'
import cn from 'classnames'

export default function Radio({
  checked,
  className,
  disabled,
  horizontal,
  id,
  label,
  name,
  value,
  ...rest
}) {
  const classes = cn('c-radio', className)
  const containerClasses = cn('c-radio__container', {
    'o-grid__item o-grid__item--shrink  u-margin-bot-none': horizontal,
  })

  const optionalLabel = label && (
    <label className="c-form__label c-form__label--radio" htmlFor={id}>
      {label}
    </label>
  )

  return (
    <div className={containerClasses}>
      <input
        defaultChecked={checked}
        className={classes}
        disabled={disabled}
        id={id}
        name={name}
        type="radio"
        value={value}
        {...rest}
      />
      {optionalLabel}
    </div>
  )
}

Radio.propTypes = {
  checked: PropTypes.bool.isRequired,
  className: PropTypes.string,
  disabled: PropTypes.bool,
  id: PropTypes.string.isRequired,
  label: PropTypes.string,
  name: PropTypes.string.isRequired,
  value: PropTypes.string,
}

Radio.defaultProps = {
  className: '',
  disabled: false,
  label: '',
  value: '',
}
